import Link from '@eversports/klimt-primitives/legacy/Link'
import { assertNever } from '@eversports/klimt-utilities/assert-never'

import { EventType } from '../../../../../../App.types'

import { PublicParticipation } from './FriendsUpcomingParticipations.types'
import { FriendUpcomingParticipationContent } from './FriendUpcomingParticipationContent'
import getEventBookableItemLink from './helpers/get-event-bookable-item-link'

interface Props {
  upcomingParticipation: PublicParticipation
  onClick: () => void
}

export function FriendUpcomingParticipationVariant({ upcomingParticipation, onClick }: Props) {
  switch (upcomingParticipation.__typename) {
    case 'PublicCourtBooking': {
      const {
        bookableItem: { venue, sport },
        timeRange,
        participationState,
      } = upcomingParticipation
      return (
        <FriendUpcomingParticipationContent
          imageSrc={venue.images[0]?.medium}
          activityName={sport.name}
          sportName={sport.name}
          start={timeRange.start}
          end={timeRange.end}
          participationState={participationState}
          venue={venue}
        />
      )
    }
    case 'PublicEventSessionParticipation': {
      const {
        bookableItem: { activityImage, activityName, sport, venue, eventType },
        timeRange,
        participationState,
      } = upcomingParticipation
      if (eventType === EventType.PRIVATE) {
        return (
          <FriendUpcomingParticipationContent
            imageSrc={activityImage?.medium}
            activityName={activityName}
            sportName={sport.name}
            start={timeRange.start}
            end={timeRange.end}
            participationState={participationState}
            venue={venue}
          />
        )
      } else {
        return (
          <Link to={getEventBookableItemLink(upcomingParticipation.bookableItem)} external blank>
            <FriendUpcomingParticipationContent
              imageSrc={activityImage?.medium}
              activityName={activityName}
              sportName={sport.name}
              start={timeRange.start}
              end={timeRange.end}
              participationState={participationState}
              venue={venue}
              onClick={onClick}
            />
          </Link>
        )
      }
    }
    case 'BallsportMatch': {
      const { sport, venue, start, end, participationState } = upcomingParticipation
      return (
        <FriendUpcomingParticipationContent
          imageSrc={venue.images[0]?.medium}
          activityName={sport.name}
          sportName={sport.name}
          start={start}
          end={end}
          participationState={participationState}
          venue={venue}
          onClick={onClick}
        />
      )
    }
    default:
      return assertNever(upcomingParticipation)
  }
}
